// src/components/LoginPage.js
// Shared login page used by the main app and AuditReview
import React from "react";

export const PadlockIcon = ({ size = 40, bg = "#534AB7" }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" style={{ flexShrink: 0 }}>
    <rect width="40" height="40" rx="8" fill={bg}/>
    <rect x="13" y="20" width="14" height="11" rx="2" fill="white"/>
    <path d="M15 20v-4a5 5 0 0110 0v4" stroke="white" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
    <circle cx="20" cy="25" r="2" fill={bg}/>
  </svg>
);

export const MsLogo = () => (
  <svg viewBox="0 0 21 21" width="21" height="21" fill="none">
    <rect x="1"  y="1"  width="9" height="9" fill="#F25022"/>
    <rect x="11" y="1"  width="9" height="9" fill="#7FBA00"/>
    <rect x="1"  y="11" width="9" height="9" fill="#00A4EF"/>
    <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
  </svg>
);

export default function LoginPage({ redirectUri }) {
  const href = redirectUri
    ? `/.auth/login/aad?post_login_redirect_uri=${encodeURIComponent(redirectUri)}`
    : "/.auth/login/aad?post_login_redirect_uri=/";

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <PadlockIcon size={72} />
        </div>
        <h1>SUFC System<br/>Governance Portal</h1>
        <p>Sign in with your Microsoft 365 account to access the portal.</p>
        <a className="ms-signin-btn" href={href}>
          <MsLogo />
          Sign in with Microsoft 365
        </a>
      </div>
    </div>
  );
}
